<template>
  <div
    :class="[
      baseClass,
      { 'bg-gray-50 cursor-not-allowed opacity-75 dark:bg-gray-900' : disabled },
      { 'ring-2 ring-primary-600' : isActive }
    ]"
  >
    <slot>
      <template v-if="value">
        <div class="flex items-center mr-2">
          {{ value }}
        </div>
      </template>
      <template v-else>
        <p class="opacity-80 mr-3 leading-none">
          {{ placeholder }}
        </p>
      </template>
    </slot>
    <o-icon icon="chevronDown" :size="10" />
  </div>
</template>

<script setup lang="ts">
const { $i18n } = useNuxtApp()

const dropdown = inject<() => any>('dropdown')

interface Props {
  placeholder?: string
  value?: string | number | object | any[] | null
  disabled?: boolean
  baseClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  placeholder: undefined,
  value: null,
  disabled: false,
  baseClass: 'w-full py-2 px-2 border dark:border-gray-800 rounded-md h-9 flex items-center justify-between cursor-pointer text-sm',
})

const placeholder = computed(() => props.placeholder ?? $i18n.t('general.selectAnOption'))

const _dropdown = computed(() => dropdown?.())
const isActive = computed(() => _dropdown.value?.show)
</script>
